<template>
  <div class="headers">
    <div class="header">
      <div class="back" @click="goback"><img src="../assets/back.png"></div>
      <div class="title">{{title}}</div>
      <div class="switch-language" @click="changeLanguage()">{{$t('language.name')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'theader',
  data () {
    return {
      fsd: ''
    }
  },
  props: {
    title: String
  },
  created () {
    if (this.$route.query.language === 'en') {
      this.curLanguage('en')
    } else {
      this.curLanguage('zh')
    }
  },
  methods: {
    curLanguage (value) {
      this.$i18n.locale = value
      this.$emit('getTitle')
    },
    changeLanguage () {
      this.$i18n.locale === 'zh' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh' // 设置中英文模式
      // localStorage.setItem('languageSet',this.$i18n.locale)   //将用户设置存储到localStorage以便用户下次打开时使用此设置
      this.$emit('getTitle')
    },
    goback () {
      location.href = 'localcall://finish'
    }
  }
}
</script>

<style scoped lang="stylus">
  .headers{
    height: 44PX;
    width: 100%;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    .header{
      position: fixed;
      top: 0;
      left: 0;
      padding-top: constant(safe-area-inset-top);
      padding-top: env(safe-area-inset-top);
      background-color: #fff;
      height: 43PX;
      line-height: 43PX;
      width: 100%;
      border-bottom: 1PX solid #eee;
      .back{
        position: absolute;
        left: 10PX;
        // top: 30PX;
        top: env(safe-area-inset-top);
        top: constant(safe-area-inset-top);
        width: 44PX;
        height: 44PX;
        img{
          width: 24PX;
          height: 24PX;
          display: block;
          margin-top: 10PX;
        }
      }
      .title{
        text-align: center;
        font-size: 16px;
        color: #333;
        font-weight: bold;
      }
      .switch-language{
        position: absolute;
        top: env(safe-area-inset-top);
        top: constant(safe-area-inset-top);
        right: 0;
        font-size: 16px;
        color: #333;
        width: 60px;
      }
    }
  }
</style>
